import type { ReactNode } from "react";

export interface BottomNavItem {
  key: string;
  label: string;
  icon: ReactNode;
}

export interface BottomNavProps {
  items: BottomNavItem[];
  activeKey: string;
  onSelect: (key: string) => void;
}

export function BottomNav({ items, activeKey, onSelect }: BottomNavProps) {
  return (
    <nav className="jaiho-bottom-nav">
      {items.map((item) => {
        const isActive = item.key === activeKey;
        return (
          <button
            key={item.key}
            type="button"
            className={`jaiho-bottom-nav__item${isActive ? " jaiho-bottom-nav__item--active" : ""}`}
            onClick={() => onSelect(item.key)}
            aria-current={isActive ? "page" : undefined}
          >
            <span className="jaiho-bottom-nav__icon">{item.icon}</span>
            <span className="jaiho-bottom-nav__label">{item.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
